import imagesLoaded from 'imagesloaded';
import App from './modules/app';


// Set 2 Promises before we init Main. Images and Window Load
const windowLoad = new Promise((resolve) => {
  window.addEventListener('load', () => {
    resolve();
  });
});
const imagesLoadedP = new Promise((resolve) => {
  const imgLoad = imagesLoaded(document.body, {
    background: true
  });
  imgLoad.on('always', () => {
    resolve();
  });
});
Promise.all([windowLoad, imagesLoadedP]).then(() => {
  new App();
});
